<template>
  <div>
    <el-form
      ref="searchForm"
      :model="searchForm"
      size="mini"
      label-width="100px"
      v-if="option.searchHas"
      :inline="true"
    >
          <el-form-item
            :label="item.label"
            :prop="item.prop"
            v-for="(item, index) in search"
            :key="index"
          >
            <div v-if="item.type=='select'">
              <el-select v-model="searchForm[item.prop]" placeholder="请选择">
                <el-option
                  v-for="itemIn in item.list"
                  :key="itemIn.value"
                  :label="itemIn.label"
                  :value="itemIn.value">
                </el-option>
              </el-select>
            </div>
            <div v-else>
              <el-input
                placeholder=""
                clearable
                v-model="searchForm[item.prop]"
                size="mini"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="mini"
              icon="iconfont iconchaxun"
              title="搜索"
              @click="searchList"
            ></el-button>
            <el-button
              size="mini"
              icon="iconfont iconshuaxin"
              @click="resetForm('searchForm')"
            ></el-button>
          </el-form-item>
    </el-form>
    <div class="">
      <el-table :data="dataList" border stripe style="width: 100%" :height="option.height || 300">
        <el-table-column
          v-for="(item, index) in table"
          :key="index"
          :prop="item.prop"
          :label="item.title"
          :width="item.width || ''"
        >
          <template slot-scope="scope">
            <span v-if="item.select"
              ><el-radio
                @change.native="getrow()"
                :label="scope.$index"
                v-model="selectIndex"
                 ><span style="color:#ffffff">*</span></el-radio
              ></span
            >
            <span v-if="item.Type=='Tag'"
              >
              <el-tag :type="item.formatter(scope.row)">{{ scope.row[item.prop]}}</el-tag>
            </span>
            
            <!-- 默认 -->
            <span
              v-else-if="!item.type"
              :style="item.itemStyle && item.itemStyle(scope.row)"
              :class="item.itemClass && item.itemClass(scope.row)"
              @click="item.fun && item.fun(scope.row)"
            >
              {{
                (item.formatter && item.formatter(scope.row)) ||
                scope.row[item.prop]
              }}</span>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="table-pagination" v-if="option.pageHas">
        <el-pagination
          background
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </div>
    <div class="text-R" slot="footer">
      <el-button type="primary" size="mini" @click.native="selectSubmit(1)"
        >确定</el-button
      >
      <el-button size="mini" @click.native="selectSubmit(0)">取消</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "MfSearchSelect",
  data() {
    return {
      searchForm: {},
      dataList: [],
      selectIndex: -1,
      page:{
        pageIndex:1,
        pageSize:10,
        total:0,
      }
    };
  },
  props: {
    search: {
      type: Array,
      default: () => {},
    },
    table: {
      type: Array,
      default: () => [],
    },
    option: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.getData();
  },
  activated() {
    
  },
  watch: {},
  methods: {
    getrow() {
      console.log(this.selectIndex);
    },
    selectSubmit(type) {
      if (type == 1) {
        if (this.selectIndex < 0) {
          this.$message.warning("请先选择一个项");
        } else if (this.selectIndex >= 0) {
          this.$emit("dataBack", this.dataList[this.selectIndex], type);
        }
      } else {
        this.$emit("dataBack", {}, type);
      }
    },
    getData() {
      console.log(this.searchForm);
      console.log(this.page.pageIndex)
      this.$reqPost(this.option.getUrl,
        {
          PageIndex: this.option.pageHas ? this.page.pageIndex : null,
          PageSize: this.option.pageHas ? this.page.pageSize : null,
          SearchParams:{...this.searchForm},
        }
      ).then(res=>{
        console.log(res)
        if (res.isSuccess===true){
          let result = res.result;
          this.dataList = this.option.pageHas ? result.Rows : result
          this.page.total = this.option.pageHas ? result.Total : 0;
        }else{
          this.dataList = []
          this.page.total = 0
          return this.$message.error("请求出错")
        }
      })
    },
    //分页, 每页条数
    pageSizeChangeHandle(val) {
      // this.tablePagination.pageSizeChangeHandle &&
      //   this.tablePagination.pageSizeChangeHandle(val);
      this.page.pageSize = val;
      this.getData();
    },
    //分页, 当前页
    pageCurrentChangeHandle(val) {
      // this.tablePagination.pageCurrentChangeHandle &&
        // this.tablePagination.pageCurrentChangeHandle(val);
        this.page.pageIndex = val;
        this.getData();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    searchList(){
      this.page.pageIndex = 1;
      this.getData();
    }
  },
};
</script>


